export default "__VITE_ASSET__766cd318__"